var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("div", { class: "boxed" }, [
    /*#__PURE__*/ _createElementVNode("h1", null, "Create")
], -1 /* HOISTED */);
const _hoisted_2 = {
    key: 1,
    class: "boxed"
};
const _hoisted_3 = { class: "list-detail-drawer__detail-section__content" };
const _hoisted_4 = { class: "component-variable-list section-wrapper" };
const _hoisted_5 = { class: "form" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("label", { for: "name" }, "Name", -1 /* HOISTED */);
const _hoisted_7 = { class: "list-detail-drawer__detail-section__footer" };
const _hoisted_8 = { class: "right" };
import { getErrorMessage } from "src/shared/store/common/Exception";
import { ref, watch } from "vue";
import { map } from "lodash";
import Button from "src/shared/v-components/ui/Button.vue";
import ExtoleDrawer from "src/shared/v-components/ui/ExtoleDrawer.vue";
import { notify } from "src/shared/v-components/ui/notification/notification-service";
import NotificationFlash from "src/shared/v-components/ui/NotificationFlash.vue";
import { useBuiltComponent } from "src/shared/store/component-built/composables";
import { useVModel } from "@vueuse/core";
import { useCampaignStore } from "src/shared/store/campaign";
import { useComponentStoreV2 } from "src/shared/store/component";
import { useComponentByTag } from "src/shared/store/component/composables";
import { useComponentMutableKeyForDuplication } from "src/shared/store/component-mutable/composables/useComponentMutableKey";
import ComponentVariableList from "src/shared/v-components/component-variable/list/ComponentVariableList.vue";
import { useComponentMutable } from "src/shared/store/component-mutable/composables/useComponentMutable";
const ENABLED_VARIABLE_NAME = "enabled";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DuplicateRewardSupplierComponentDrawer',
    props: {
        componentId: {},
        modelValue: { type: Boolean }
    },
    emits: ["closed", "update:modelValue", "duplicated"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const componentStore = useComponentStoreV2();
        const campaignStore = useCampaignStore();
        const isOpen = useVModel(props, "modelValue", emit);
        const { builtComponent: targetComponent } = useBuiltComponent(() => props.componentId || undefined);
        const { component: componentToDuplicate, primer } = useComponentByTag(() => { var _a; return `internal:${(_a = targetComponent.value) === null || _a === void 0 ? void 0 : _a.name}`; });
        const { componentMutableKey } = useComponentMutableKeyForDuplication(() => { var _a; return (_a = componentToDuplicate.value) === null || _a === void 0 ? void 0 : _a.id; });
        const componentName = ref("");
        watch(() => { var _a; return (_a = componentToDuplicate.value) === null || _a === void 0 ? void 0 : _a.id; }, () => {
            if (componentToDuplicate.value) {
                componentName.value = componentToDuplicate.value.name;
            }
        }, { immediate: true });
        const isDuplicating = ref(false);
        const duplicate = () => __awaiter(this, void 0, void 0, function* () {
            const { componentMutable } = useComponentMutable(componentMutableKey.value);
            if (!componentMutable.value ||
                !componentToDuplicate.value ||
                !targetComponent.value) {
                return;
            }
            map(componentMutable.value.getVariables(), (variable) => {
                if (variable.getName() === ENABLED_VARIABLE_NAME) {
                    variable.setValue("default", true);
                }
            });
            try {
                isDuplicating.value = true;
                yield componentStore.duplicateComponentV2({
                    sourceComponentId: componentToDuplicate.value.id,
                    targetCampaignId: targetComponent.value.campaign_id,
                    targetComponentId: targetComponent.value.id,
                    componentName: componentName.value,
                    variables: componentMutable.value.getVariables(),
                    tags: componentToDuplicate.value.tags,
                    component_ids: componentToDuplicate.value.component_ids,
                });
                yield campaignStore.publishDraft(targetComponent.value.campaign_id, {
                    message: null,
                    launch: true,
                });
                notify({
                    type: "success",
                    message: `${componentName.value} has been created`,
                });
                isOpen.value = false;
                emit("duplicated");
            }
            catch (error) {
                notify({
                    type: "error",
                    message: getErrorMessage(error),
                });
            }
            finally {
                isDuplicating.value = false;
                isOpen.value = false;
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(ExtoleDrawer, {
                modelValue: _unref(isOpen),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (_isRef(isOpen) ? (isOpen).value = $event : null)),
                showClose: false,
                width: "708px",
                "destroy-on-close": true,
                onClose: _cache[2] || (_cache[2] = ($event) => (emit('closed')))
            }, {
                title: _withCtx(() => [
                    _hoisted_1
                ]),
                footer: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                            _createVNode(Button, {
                                onClick: _withModifiers(duplicate, ["prevent"]),
                                "is-pending": isDuplicating.value
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode("Save")
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["is-pending"])
                        ])
                    ])
                ]),
                default: _withCtx(() => [
                    (_unref(primer).isLoading)
                        ? (_openBlock(), _createBlock(NotificationFlash, { key: 0 }))
                        : _createCommentVNode("v-if", true),
                    (_unref(primer).isReady && _unref(componentToDuplicate))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("div", _hoisted_4, [
                                    _createElementVNode("div", _hoisted_5, [
                                        _hoisted_6,
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            name: "name",
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((componentName).value = $event))
                                        }, null, 512 /* NEED_PATCH */), [
                                            [_vModelText, componentName.value]
                                        ])
                                    ])
                                ]),
                                (_unref(componentMutableKey))
                                    ? (_openBlock(), _createBlock(ComponentVariableList, {
                                        key: 0,
                                        "component-mutable-key": _unref(componentMutableKey),
                                        type: 'STANDARD'
                                    }, null, 8 /* PROPS */, ["component-mutable-key"]))
                                    : _createCommentVNode("v-if", true)
                            ])
                        ]))
                        : _createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue"]));
        };
    }
});
